import { FormlyModule } from '@ngx-formly/core';
import { FormlyMatFormFieldModule } from '@ngx-formly/material/form-field';
import { FormlyMatToggleModule } from '@ngx-formly/material/toggle';
import { NgxUploaderModule } from 'ngx-uploader';

import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';

import { SnFormFieldGroupModule } from '@lib/form/form-field-group';
import { TranslationModule, t } from '@lib/translation';
import { SnButtonModule } from '@lib/ui/button';
import { SnIconModule } from '@lib/ui/icon';

import { SnFormComponent } from './components';
import { AddDateTimeFieldDialogComponent } from './components/add-date-time-field-dialog/add-date-time-field-dialog.component';
import { AddFieldDialogComponent } from './components/add-field-dialog/add-field-dialog.component';
import { EditFieldDialogComponent } from './components/edit-field-dialog/edit-field-dialog.component';
import { SnValidators } from './form.validators';
import { rawValidationMessageHandler } from './helpers/raw-validation-message-handler';
import { SnRemoveAriaLabelDirective } from './helpers/remove-aria-label.directive';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    // Others
    FormlyModule,
    NgxUploaderModule,
    TranslationModule,
    // Libs
    SnIconModule,
    SnButtonModule,
    SnFormFieldGroupModule,
  ],
  exports: [
    // Angular
    FormsModule,
    ReactiveFormsModule,
    // Material
    MatFormFieldModule,
    // Others
    FormlyMatToggleModule,
    FormlyMatFormFieldModule,
    // Components
    SnFormComponent,
    SnRemoveAriaLabelDirective,
  ],
  declarations: [
    // Components
    SnFormComponent,
    AddFieldDialogComponent,
    AddDateTimeFieldDialogComponent,
    EditFieldDialogComponent,
    SnRemoveAriaLabelDirective,
  ],
})
export class SnFormModule {
  public static forRoot(): ModuleWithProviders<FormlyModule> {
    return FormlyModule.forRoot({
      validators: [
        { name: 'port', validation: SnValidators.port },
        { name: 'email', validation: SnValidators.email },
        { name: 'ipAddress', validation: SnValidators.ipAddress },
        { name: 'password', validation: SnValidators.password },
        { name: 'alphanumeric', validation: SnValidators.alphanumeric },
        { name: 'alpha', validation: SnValidators.alpha },
        { name: 'numeric', validation: SnValidators.numeric },
        { name: 'time', validation: SnValidators.time },
        { name: 'noWhitespace', validation: SnValidators.noWhitespace },
        { name: 'hasEmojis', validation: SnValidators.hasEmojis },
        { name: 'uuid', validation: SnValidators.uuid },
        { name: 'uri', validation: SnValidators.url() },
      ],
      validationMessages: [
        { name: 'server', message: rawValidationMessageHandler },
        { name: 'url', message: () => t('common.validation.url') },
        { name: 'port', message: () => t('common.validation.port') },
        { name: 'email', message: () => t('common.validation.email') },
        { name: 'password', message: () => t('common.validation.password') },
        { name: 'required', message: () => t('common.validation.required') },
        { name: 'alphanumeric', message: () => t('common.validation.alphanumeric') },
        { name: 'alpha', message: () => t('common.validation.alpha') },
        { name: 'numeric', message: () => t('common.validation.numeric') },
        { name: 'time', message: () => t('common.validation.time') },
        { name: 'noWhitespace', message: () => t('common.validation.noWhitespace') },
        { name: 'hasEmojis', message: () => t('common.validation.hasEmojis') },
        {
          name: 'maxLength',
          message: (err, _field) =>
            t(
              'common.validation.maxLengthWithDetails',
              { requiredLength: err.requiredLength, actualLength: err.actualLength }
            ),
        },
        {
          name: 'minLength',
          message: (err, _field) =>
            t(
              'common.validation.minLengthWithDetails',
              { requiredLength: err.requiredLength, actualLength: err.actualLength }
            ),
        },
        { name: 'uuid', message: () => t('common.validation.uuid') },
      ],
    });
  }
}
